export default __webpack_public_path__ + "static/media/cards.9d4ed79b.png";